import React from 'react';
import ToolsPage from 'core/views/admin/ToolsPage';

const Tools = () => <ToolsPage />;

export default Tools;
